/**
 * GranularityToggle — 3-button toggle for day / week / month granularity.
 *
 * Auto-detection logic (hint only — user can override):
 *   periodDays < 30   → suggest 'day'
 *   periodDays 30-180 → suggest 'week'
 *   periodDays > 180  → suggest 'month'
 *
 * Props:
 *   value       : 'day' | 'week' | 'month'
 *   onChange    : (newValue: string) => void
 *   periodDays  : number   (total days in selected period, drives suggestion badge)
 */

const OPTIONS = [
  { value: 'day', label: 'Jour' },
  { value: 'week', label: 'Semaine' },
  { value: 'month', label: 'Mois' },
];

export function suggestGranularity(periodDays) {
  if (periodDays < 30) return 'day';
  if (periodDays <= 180) return 'week';
  return 'month';
}

export default function GranularityToggle({ value, onChange, periodDays }) {
  const suggested = periodDays != null ? suggestGranularity(periodDays) : null;

  return (
    <div className="flex items-center gap-1" role="group" aria-label="Granularité">
      {OPTIONS.map((opt) => {
        const isActive = value === opt.value;
        const isSuggested = suggested === opt.value && !isActive;
        return (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            aria-pressed={isActive}
            className={[
              'relative px-3 py-1.5 text-xs font-medium rounded-lg border transition-colors',
              isActive
                ? 'bg-slate-800 text-white border-slate-800'
                : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50',
            ].join(' ')}
          >
            {opt.label}
            {isSuggested && (
              <span
                className="absolute -top-1 -right-1 w-2 h-2 rounded-full bg-sky-400"
                title="Granularité suggérée pour cette période"
                aria-label="granularité suggérée"
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
